<template>
    <vs-tabs :value="0">
        <vs-tab label="SUB MERCHANT ">
            <vx-card class="mb-5">
                <div class="vx-row mb-12">
                    <div class="vx-col sm:w-4/5">
                        &nbsp;
                    </div>
                    <div class="vx-col sm:w-1/5">
                        <vs-button id="btn-export-to-csv" color="success" icon-pack="feather" icon="icon-file" v-on:click="exportToCSV()" class="mr-3 mb-2 float-left">Export to CSV</vs-button>
                    </div>
                </div>
            <div id="ag-grid-demo">
                <ag-grid-vue
                    :gridOptions="gridOptions"
                    class="ag-theme-material w-100 my-4 ag-grid-table"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="subMerchants"
                    rowSelection="multiple"
                    colResizeDefault="shift"
                    :animateRows="true"
                    :floatingFilter="true"
                    :pagination="true"
                    :paginationPageSize="limit"
                    :suppressPaginationPanel="true"
                    :enableCellTextSelection="true"
                    :autoParamsRefresh="true"
                ></ag-grid-vue>
                <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage"/>
            </div>
            </vx-card>
        </vs-tab>
        <vs-tab label="MERCHANT TREE">
                  <div>
                      <tree-merchant />
                  </div>
        </vs-tab>
    </vs-tabs>
</template>

<script>
    import moment from 'moment';
    import {AgGridVue} from "ag-grid-vue"
    import {url} from "@/configs/apiUrl"
    import Axios from "@/global/AxiosCall"
    import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss"
    import ActionTableAgGridComponent from "@/components/cell-render-component/ActionTableEditDeleteAgGridComponent"
    import ActiveInactiveAgGridComponent from "@/components/cell-render-component/ActiveInactiveAgGridComponent"
    import MerchantAPI from "@/network/api/MerchantAPI";
    import TreeMerchant from "./TreeMerchant";

    export default {
        name: 'submerchantList',
        props: {
            onFetchCallback: {type: Function},
        },
        components: {
            AgGridVue,
            TreeMerchant
        },
        data() {
            return {
                searchQuery: "",
                gridOptions: {},
                maxPageNumbers: 7,
                gridApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true,
                    // filterParams: {
                    //   applyButton: true,
                    //   newRowsAction: 'keep'
                    // },
                },
                columnDefs: [
                    {
                        headerName: "Submerchant Name",
                        field: "full_name",
                        width: 250,
                        filter: true,
                        editable: false,
                        pinned: "left"
                    },
                    {
                        headerName: "Submerchant ID",
                        field: "id",
                        width: 180,
                        filter: true,
                        editable: false,
                    },
                    {
                        headerName: "Submerchant Code",
                        field: "code",
                        width: 250,
                        filter: true,
                        editable: false
                    },
                    {
                        headerName: "Merchant Name",
                        field: "parent_full_name",
                        width: 250,
                        filter: true,
                        editable: false,
                    },
                    {
                        headerName: "Email",
                        field: "email",
                        filter: true,
                        editable: false,
                        width: 250
                    },
                    {
                        headerName: "Merchant Category",
                        field: "merchant_categories",
                        filter: true,
                        editable: false,
                        width: 250
                    },
                    {
                        headerName: "Phone Number",
                        field: "phone",
                        filter: true,
                        editable: false,
                        width: 250
                    },
                    {
                        headerName: "Registered Date",
                        field: "created_at",
                        filter: true,
                        editable: false,
                        width: 200
                    },
                    {
                        headerName: "Status",
                        field: "status",
                        filter: true,
                        editable: false,
                        width: 200,
                        cellRendererFramework: ActiveInactiveAgGridComponent
                    },
                    {
                        headerName: "Actions",
                        field: "id",
                        filter: false,
                        editable: false,
                        cellRendererFramework: ActionTableAgGridComponent,
                        width: 200
                    }
                ],
                subMerchants: [],
                dataCount: 0,
                totalPage: 0,
                page: 1,
                limit: 20,
                totalData: 1,
                parent_id:''
            }
        },
        watch: {},
        computed: {
            currentPage: {
                get() {
                    if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                    else return 1
                },
                set(val) {
                    this.fetchData(val, this.limit)
                }
            }
        },
        methods: {
            //@filter-changed="onFilterModified"
            // onFilterModified(event){
            //   console.log("modified", JSON.stringify(event.api.getFilterModel()))
            //   console.log(Object.keys(event.api.getFilterModel()))
            //   this.subMerchants = []
            // },
            openLoading() {
              this.$vs.loading({
                type: "default"
              });
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            },
            fetchData(page, limit) {
                this.openLoading()
                let newPage = page
                if (this.dataCount != 0) {
                    let totalPages = Math.ceil(this.dataCount / limit)
                    if (page > totalPages) {
                        newPage = totalPages
                    }
                }

                Axios.Get(
                    url.svd.merchant.getSubmerchants + "?page=" + newPage + "&limit=" + limit + "&parent_id="+this.parent_id
                )
                    .then(resp => {
                        this.$vs.loading.close()
                        this.subMerchants = []
                        if (resp.data.data.length != 0) {
                            this.totalData = parseInt(resp.data.total)
                            let no = 1
                            for (let data of resp.data.data) {
                                data.no = no
                                this.subMerchants.push(data)
                                no++
                            }

                            this.dataCount = resp.data.total
                            this.page = page
                            if (limit >= this.dataCount) {
                                this.limit = this.subMerchants.length
                            } else {
                                this.limit = limit
                            }

                            // this.gridApi.paginationSetPageSize(this.limit)
                            this.totalPage = resp.data.lastPage

                            /*const payload = {
                                totalPage: this.totalPage,
                                totalData: this.totalData,
                                page: this.page,
                                limit: this.limit,
                                dataCount: this.dataCount,
                                gridApi: this.gridApi,
                                event: 'submerchant-list'
                            }

                            this.onFetchCallback(payload)*/
                        }
                    })
                    .catch(e => {
                        this.$vs.loading.close()
                        console.log(e)
                    })
            },
            exportToCSV() {
                Axios.Get(
                    url.svd.merchant.getSubmerchants + "?page=" + 1 + "&limit=" + 1000 + "&parent_id="+this.parent_id
                )
                .then(resp => {
                    let dataExport = "#,SUBMERCHANT_NAME,SUBMERCHANT_ID,SUBMERCHANT_CODE,MERCHANT_NAME,EMAIL,CATEGORY,PHONE_NUMBER,REGISTERED_DATE,STATUS" + "\n"
                    let no = 1
                    let parentFullName = ""
                    for(const data of resp.data.data) {
                        parentFullName = data.parent_full_name
                        dataExport += no + ","
                        dataExport += data.full_name + ","
                        dataExport += data.id + ","
                        dataExport += data.code + ","
                        dataExport += data.parent_full_name + ","
                        dataExport += data.email + ","
                        if (data.merchant_categories!=null) {
                            dataExport += data.merchant_categories + ","
                        } else {
                            dataExport += ","
                        }
                        dataExport += data.phone + ","
                        dataExport += data.created_at + ","
                        dataExport += data.status + ","
                        dataExport += "\n"
                        no++
                    }
                    const url = window.URL.createObjectURL(new Blob([dataExport]));
                    const link = document.createElement('a');
                    link.href = url;
                    parentFullName = parentFullName.replaceAll(".", "")
                    parentFullName = parentFullName.replaceAll(" ", "-")
                    let now = moment().format("_HH-mm-ss_DD-MM-YYYY")
                    let file_name = "Export_Submerchant_Data_" + parentFullName + now + ".csv"
                    link.setAttribute('download', file_name);
                    document.body.appendChild(link);
                    link.click()
                    link.remove()
                })
            },
            editRecord(value) {
                if (value.parent_id !== 0) {
                    this.$router.push({
                        name: "submerchantEdit",
                        params: {
                            id: value.id,
                            parent_id:this.parent_id
                        }
                    })
                } else {
                    this.$router.push({
                        name: "merchantEdit",
                        params: {
                            id: value.id
                        }
                    })
                }
            },
            configureRecord(value) {
                this.$router.push({
                    name: "MerchantConfiguration",
                    params: {
                        id: value
                    }
                })
            },
            deleteRecord(data) {
                let root = this
                this.$vs.dialog({
                    type: "confirm",
                    color: "primary",
                    title: `Confirm`,
                    text: "Are you sure deleted this record ?",
                    accept: () => {
                        Axios.Delete(url.svd.merchant.account_info + "/" + data)
                            .then(resp => {
                                if (resp.data === true) {
                                    root.fetchData(root.page, root.limit)
                                    this.$vs.notify({
                                        title: "Success",
                                        text: "Successfully deleted!",
                                        iconPack: "feather",
                                        icon: "icon-check-square",
                                        color: "success",
                                        position: "top-right"
                                    })
                                }
                            })
                            .catch(e => {
                                console.log(e)
                                this.$vs.notify({
                                    title: "Failed",
                                    text: "Network failed!",
                                    iconPack: "feather",
                                    icon: "icon-alert-circle",
                                    color: "danger",
                                    position: "top-right"
                                })
                            })
                    }
                })
            },
            statusChange(params) {
                let status = ''
                if (params.statusValue) {
                    status = 'active'
                } else {
                    status = 'inactive'
                }

                let payload = {
                    id: params.data.id,
                    status: status,
                    notify: this.$vs.notify
                }

                MerchantAPI.SetStatus(payload).then(() => {
                    this.$store.dispatch('createAuditTrail', {
                        user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                        session_id: parseInt(localStorage.getItem('sessID')),
                        user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                        menu:      "Merchant Management",
                        activity: "Status Change Submerchant",
                        data_before: params,
                        data_after: payload,
                    })
                    this.$vs.notify({
                        title: "Success",
                        text: "Merchant status updated!",
                        iconPack: "feather",
                        icon: "icon-check-square",
                        color: "success",
                        position: "top-right"
                    })
                }).catch(e => {
                    this.$vs.notify(e.response.data.notify)
                    let updatedElementIndex = this.subMerchants.findIndex(subMerchant => subMerchant.id === payload.id)
                    this.subMerchants[updatedElementIndex].status = (status === 'active') ? 'inactive' : 'active'
                })
            }
        },
        beforeMount() {
            const role = localStorage.getItem("userRole")
            if (!(role == 'root' || role == 'administrator' || role == 'aino_cc')) {
                // this.$delete(this.columnDefs, this.columnDefs.length - 1)
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api
            this.gridOptions.getRowStyle = function(params) {
                if (params.node.rowIndex % 2 === 0) {
                    return { background: '#f9f9f9' }
                }
            }
            this.gridOptions.rowHeight = 42;

            this.parent_id = this.$route.params.id

            this.$root.$on("delete-from-ActionTableAgGridComponent", data => {
                this.deleteRecord(data)
            })

            this.$root.$on("edit-from-ActionTableAgGridComponent", data => {
                this.editRecord(data)
            })

            this.$root.$on("configure-from-ActionTableAgGridComponent", data => {
                this.configureRecord(data)
            })

            this.$root.$on("status-from-ActiveInactiveAgGridComponent", data => {
                this.statusChange(data)
            })

            this.$root.$on("submerchant-list", data => {
                this.fetchData(data.page, data.limit)
            })
        }
    }
</script>